<template>
    <van-popup class="van-popup-radius" :value="showCalendarYearPop" position="bottom"  @click-overlay="clickCancel">
        <van-picker 
            show-toolbar 
            :columns="calendarYearList"
            :default-index="calendarYearIndex"
            @cancel="clickCancel"
            @confirm="clickConfirm"
        />
    </van-popup>
</template>

<script>
export default {
    name: 'CalendarYearPop',
    computed: {
        showCalendarYearPop() {
            return this.$store.state.calendar.showCalendarYearPop;
        },
        calendarYearList: {
            get() {
                return this.$store.state.calendar.calendarYearList;
            },
            set(value) {
                this.$store.state.calendar.calendarYearList = value;
            }
        },
        calendarYearIndex() {
            return this.$store.state.calendar.calendarYearIndex;
        }
    },
    methods: {
        clickCancel() {
            this.$store.state.calendar.showCalendarYearPop = false;
        },
        clickConfirm(value) {
            this.$store.state.calendar.showCalendarYearPop = false;
            this.$store.dispatch('calendar/initCalendarJieQi', value);
        }
    }
}
</script>